export class GlobalAlertMessage {
    title: string='';
    message: string='';
}